// extracted by mini-css-extract-plugin
module.exports = {"badgeWrapper":"CylinderGroupByStatus_badgeWrapper__2Q5-K"};